module.exports = __webpack_public_path__ + "static/media/activity-url.24d19453.png";